import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=1bcb73ae&scoped=true"
import script from "./todo.vue?vue&type=script&lang=ts"
export * from "./todo.vue?vue&type=script&lang=ts"
import style0 from "./todo.vue?vue&type=style&index=0&id=1bcb73ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb73ae",
  null
  
)

export default component.exports